import { FC } from "react";
import { Button, Icon, RenderWhen } from "../../../../../components";
import BuyMoreQuotaConfirmationModal from "./BuyMoreQuotaConfirmationModal";
import useToggle from "../../../../../hooks/useToggle";
import { isAdmin } from "../../../../../utils";
import { useRequestRlcsQuotaIncrease } from "../../../hooks";

type RlcsQuotaLimitInfoProps = {
  isHighUsage: boolean;
  isMaxedOut: boolean;
  displayPercent: string;
  messageOnly?: boolean;
};

const RlcsQuotaLimitInfo: FC<RlcsQuotaLimitInfoProps> = ({
  isHighUsage,
  isMaxedOut,
  displayPercent,
  messageOnly
}) => {
  const [showModal, , toggleModal] = useToggle(false);
  if (isHighUsage) {
    return (
      <div className="flex text-color-warning bold">
        <Icon
          name="pie-chart-warning"
          className="me-5"
          data-testid="rlcs_quota_high_usage_icon"
        />{" "}
        {displayPercent}
      </div>
    );
  }

  if (isMaxedOut && !isAdmin()) {
    return (
      <div className="flex align-items-center text-color-lighter fs-sm">
        Daily Quota Exceeded, Reach Out to Your Admin
      </div>
    );
  }

  const { requestQuotaIncrease, isPending } = useRequestRlcsQuotaIncrease({
    onSuccess: () => toggleModal()
  });

  if (isMaxedOut) {
    return (
      <>
        <div
          className="flex align-items-center text-color-lighter fs-sm"
          onClick={e => {
            e.preventDefault();
          }}
        >
          {messageOnly
            ? "Daily Cloud Sandbox Quota Exceeded"
            : "Daily Quota Exceeded"}
          <RenderWhen condition={!messageOnly}>
            <Button
              variant="secondary"
              onClick={e => {
                e.preventDefault();
                requestQuotaIncrease();
              }}
              useUpdatedStyles
              className="ms-10"
              data-testid="rlcs_quota_buy_more_button"
            >
              {isPending ? "Sending Request..." : "BUY MORE QUOTA"}
            </Button>
          </RenderWhen>
        </div>
        <BuyMoreQuotaConfirmationModal show={showModal} onClose={toggleModal} />
      </>
    );
  }

  return undefined;
};

export default RlcsQuotaLimitInfo;
